/**
 * Banner-Component
 * 
 * Attila Németh, UBG
 * 04.04.2019
 */
 
import {Component, OnInit} from '@angular/core';
import {BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'ubg-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class UbgBannerComponent implements OnInit {
  
  isMobile: boolean = false;
  isWide: boolean = false;

  constructor(private breakpoint: BreakpointObserver) {}
  
  ngOnInit() {
    this.breakpoint
      .observe([Breakpoints.XSmall])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    this.breakpoint
      .observe([Breakpoints.Medium, Breakpoints.Large,Breakpoints.XLarge])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isWide = true;
        } else {
          this.isWide = false;
        }
      });
  }
  
  getClasses() {
    let classes = [];
    if (this.isMobile) {
      classes.push('mobile');
    }
    return classes.join(' ');
  }
  
}